<template>
    <div id="back-forward-buttons" class="lb-btn-container">
        <div class="red-pill-button-of-hate go-next extra-left-margin" v-on:click="openProject()">Открыть</div>
    </div>
</template>

<script>
    export default {
        name: "RightLowerBarLiteOpenProject",
        props: {
            version: {
                type: String
            }
        },
        computed: {
            activeStep() {
                return this.$store.state.route.name
            },
            stepsOrder(){
                return this.$store.state.UI.stepsChain[this.version].stepsOrder;
            },
            adjacentSteps() {
                return this.stepsOrder[this.activeStep]
            }
        },
        methods: {
            openProject() {
                this.$router.push({name: this.adjacentSteps.next}).catch(() => {})
            }
        }
    }
</script>

<style scoped>

</style>
